const ua = window.navigator.userAgent;

/**
 * @reference 部分判断参考 https://github.com/hgoebl/mobile-detect.js
 */
export const detectEnv = {
  /**
   * 宜享花
   */
  yxh: /xiaodai/i.test(ua),
  /**
   * 宜人贷
   */
  yrd: /yrd/i.test(ua),
  /**
   * 钱有余
   */
  qyy: /qianyouyu/i.test(ua),
  /**
   * iOS
   */
  ios: /\biPhone|\biPod|\biPad|AppleCoreMedia/i.test(ua),
  /**
   * Android
   */
  android: /Android/i.test(ua),
  /**
   * HarmonyOS Next
   */
  harmony: /ArkWeb/i.test(ua),
  /**
   * 微信
   */
  wechat: /\bMicroMessenger\b/i.test(ua),
  /**
   * 微博
   */
  weibo: /weibo/i.test(ua),
  /**
   * UC浏览器
   */
  ucbrowser: /UC.*Browser|UCWEB/i.test(ua),
  /**
   * 小米浏览器
   */
  miuibrowser: /MiuiBrowser/i.test(ua),
  /**
   * QQ浏览器
   */
  qqbrowser: /MQQBrowser/i.test(ua),
  /**
   * 三星浏览器
   */
  samsungbrowser: /SamsungBrowser/i.test(ua),
  /**
   * 华为浏览器
   */
  huaweibrowser: /(HuaweiBrowser|HBPC\/)/i.test(ua),
  /**
   * 荣耀浏览器
   */
  honorbrowser: /bdhonorbrowser/i.test(ua),
  /**
   * OPPO浏览器
   */
  oppobrowser: /HeyTapBrowser/i.test(ua),
  /**
   * Vivo浏览器
   */
  vivobrowser: /VivoBrowser/i.test(ua),
  /**
   * 微信小程序
   */
  weapp: /\bMicroMessenger\b/i.test(ua) && /miniprogram/i.test(ua),
  /**
   * 支付宝小程序
   */
  aliapp: /aliapp/i.test(ua),
  /**
   * 抖音/字节小程序
   */
  dyapp: /toutiaomicroapp/i.test(ua),
};

export const detectManufacturer = {
  /**
   * 小米/红米设备
   */
  xiaomi: /mi(?![a-z])/i.test(ua),
  /**
   * 三星设备
   */
  samsung: /(?:samsung|sm-)/i.test(ua),
  /**
   * 华为设备
   */
  huawei: /huawei/i.test(ua),
  /**
   * 荣耀设备
   */
  honor: /honor/i.test(ua),
  /**
   * OPPO设备
   */
  oppo: /oppo/i.test(ua),
  /**
   * Vivo设备
   */
  vivo: /vivo/i.test(ua),
};
